import Swal from "sweetalert2";
import APIManager from "./apiManager";

export const doCheckLogin = (userData, setUsuario) => {
  // setUsuario({nombre: 'Usuario de Prueba'});
  APIManager.sendRequest('post', 'usuario', 'me', {}, (response) => {
    if (response.success) {
      setUsuario(response.data.usuario);
    } else {
      setUsuario(null);
    }
  });
}

export  const doLogout = (setUsuario) => {
    APIManager.sendRequest('post', 'usuario', 'logout', {}, (response) => {
      if (response.success) {
        setUsuario(null);
      }
    });
  }

export  const doLogin = (userData, setUsuario) => {
    APIManager.sendRequest('post', 'usuario', 'login', userData, (response) => {
      if (response.success) {
        setUsuario(response.data.usuario);
      } else {
        Swal.fire({
          // title: 'Login incorrecto',
          html: `${response.errors[0].message}`,
          icon: 'error',
          confirmButtonColor: '#08996B',
          confirmButtonText: 'ACEPTAR',
          allowOutsideClick: false,
        })
      }
    });
  }

